// @ts-check
import React from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useAISidebar } from "src/hooks/useAISidebar";
import { AIChatV3Window } from "../AIContent";

export const AINav = () => {
  const { enableAIChat, enableAIDashboards } = useWorkspaceFeatureFlags();

  const { isOpen } = useAISidebar();

  // The consolidated pane is also the dashboard builder, so dashboard
  // workspaces need it even when the standalone AI chat flag is off.
  if (!enableAIChat && !enableAIDashboards) {
    return null;
  }

  return <AIChatV3Window isOpen={isOpen} />;
};
